import React, { useMemo } from 'react';
import {
  Col, Row, Spinner,
} from 'react-bootstrap';
import { useSelector } from 'react-redux';

import FilterSelector from 'components/Flux/Automatic/FilterSelector';
import ActiveFilters from 'components/Flux/Automatic/ActiveFilters';
import Graph from 'components/Flux/Automatic/Daily/Graph';
import RoundInfoPopover from 'components/Flux/Automatic/Daily/RoundInfoPopover';
import Snackbar from 'components/DesignSystem/Snackbar';
import useDailyData from 'utils/hooks/flux/automatic/useDailyData';
import useFluxAutomaticZipDownload from 'utils/hooks/flux/automatic/useFluxAutomaticZipDownload';
import usePastSimulationNames from 'utils/hooks/flux/automatic/usePastSimulationNames';
import { DailyData, buildSubdivisionParam } from 'helper/flux/automatic';
import {
  selectFluxAutomaticControlPanelSpatialSubdivision,
  selectFluxAutomaticControlPanelAutomaticStudyScenarios,
} from 'redux/reducers/fluxAutomaticControlPanelReducer';

export default function DailyDesktop() {
  const { pastSimulationNames } = usePastSimulationNames();
  const models = useSelector(selectFluxAutomaticControlPanelAutomaticStudyScenarios);
  const { data, rodadas, isFetching } = useDailyData();
  const subdivision = useSelector(selectFluxAutomaticControlPanelSpatialSubdivision);
  const dataIsEmpty = Object.keys(data).length === 0;
  const spatialSubdivisionParam = useMemo(() => buildSubdivisionParam(subdivision), [subdivision]);
  const { DownloadZipButton, DownloadConfirmationDialog } = useFluxAutomaticZipDownload({
    models,
    type: 'daily',
    pastSimulationNames,
    spatialSubdivisionParam,
  });

  return (
    <div className="pt-4 px-5">
      <DownloadConfirmationDialog />
      <Row className="align-items-center mb-3">
        <Col className="pe-0 flux-automatic-filter-selector-container"><FilterSelector /></Col>
        <Col className="ps-0"><ActiveFilters /></Col>
        <Col xs="auto" className="d-flex align-items-center gap-2">
          <RoundInfoPopover scenarioNames={Object.keys(data)} rodadas={rodadas} />
          <DownloadZipButton />
        </Col>
      </Row>
      <Row>
        {isFetching && <div className="text-center py-4"><Spinner /></div>}
        {!isFetching && dataIsEmpty && (
          <Snackbar>
            Nenhum dado para os filtros selecionados.
          </Snackbar>
        )}
        {!isFetching && !dataIsEmpty && <Graph data={data as DailyData} rodadas={rodadas} />}
      </Row>
    </div>
  );
}
